import styled from 'styled-components'
import css from '@styled-system/css'
import React from 'react'
import Link from 'next/link'
import Button from 'components/generic/Button'

const UpgradeCTAIcon = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='presentation'
  >
    <path d='M6 0L7.6 4.4L12 6L7.6 7.6L6 12L4.4 7.6L0 6L4.4 4.4L6 0Z' fill='white' />
  </svg>
)

const UpgradeCta = () => (
  <Link href='/upgrade' passHref>
    <UpgradeItem>
      <UpgradeCTAIcon />
      Upgrade
    </UpgradeItem>
  </Link>
)

export default UpgradeCta

export const UpgradeItem = styled(Button)`
  ${css({
    p: '6px',
    fontSize: 1,
  })}
`
